// Affiliate referral tracking helpers.
// - captureRef() reads ?ref=CODE from the URL and stores it in a cookie for 30 days.
// - getRef() returns the stored ref code or null.
// - clearRef() wipes it (rarely needed).
// Cookie name: rp_ref

const COOKIE = 'rp_ref';
const MAX_AGE_DAYS = 30;

function setCookie(name, value, days) {
  if (typeof document === 'undefined') return;
  const expires = new Date(Date.now() + days * 864e5).toUTCString();
  document.cookie = `${name}=${encodeURIComponent(value)}; Expires=${expires}; Path=/; SameSite=Lax`;
}

function readCookie(name) {
  if (typeof document === 'undefined') return null;
  const match = document.cookie.match(new RegExp(`(?:^|; )${name}=([^;]*)`));
  return match ? decodeURIComponent(match[1]) : null;
}

export function captureRef() {
  if (typeof window === 'undefined') return null;
  try {
    const params = new URLSearchParams(window.location.search);
    const code = params.get('ref');
    if (code && code.trim()) {
      setCookie(COOKIE, code.trim(), MAX_AGE_DAYS);
      // Fire a lightweight click-track ping (non-blocking)
      try {
        import('@/lib/api').then(({ api }) => {
          api.get(`/affiliate/track?ref=${encodeURIComponent(code.trim())}`).catch(() => {});
        });
      } catch { /* ignore */ }
      return code.trim();
    }
  } catch { /* ignore */ }
  return readCookie(COOKIE);
}

export function getRef() {
  return readCookie(COOKIE);
}

export function clearRef() {
  setCookie(COOKIE, '', -1);
}
